import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {AppConstants} from '../../shared/constants/app-constants';
import {AlertMessageDialogComponent} from '../alert-message-dialog/alert-message-dialog.component';
import {SetupTotpAction} from './setup-totp.action';
import {DomSanitizer} from '@angular/platform-browser';


@Component({
    selector: 'app-setup-totp-dialog',
    templateUrl: './setup-totp-dialog.component.html',
    styleUrls: ['./setup-totp-dialog.component.css'],
    standalone: false
})
export class SetupTotpDialogComponent extends SetupTotpAction implements OnInit {
  security_code: number;
  totp_security_code: number;
  user_id: any;
  emailSent = false;
  app_2fa_secret = null;
  qr_code = null;
  user_data: any;

  constructor(private dialogRef: MatDialogRef<SetupTotpDialogComponent>, snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: any, dataManager: DataManagerService, private dialog: MatDialog, private sanitizer: DomSanitizer) {
    super();
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.getOtpUrl = AppConstants.BASE_URL + '/app-2fa-setup/send-email';
    this.verifyOtpUrl = AppConstants.BASE_URL + '/app-2fa-setup/verify';
    this.completeOtpUrl = AppConstants.BASE_URL + '/app-2fa-setup/complete';
    this.user_email = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_EMAIL));
    this.user_data = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER));
    this.loadFlag = false;
    this.loadFlag2 = false;
  }

  ngOnInit() {

  }

  sendEmail() {
    this.sendOtpEmail({});
  }

  verify() {
    const requestPayload = {
      app_2fa_code: this.security_code
    };
    this.verifyOtp(requestPayload);
  }

  complete() {
    const requestPayload = {
      app_2fa_code: this.totp_security_code,
      app_2fa_secret: this.app_2fa_secret
    };
    this.completeOtp(requestPayload);
  }

  protected passSendOtpEmailResponse(res) {
    this.loadFlag2 = false;
    this.emailSent = true;
    this.showSnackBar('OTP sent successfully', 'OK', 3000);

  }

  protected passSendOtpEmailError(error) {
    this.loadFlag2 = false;
    this.errorMsg = error.message;
    const data = {
      message: this.errorMsg, isIcoEnable: true
    };
    this.dialog.open(AlertMessageDialogComponent, {data, disableClose: true, width: '500px'});
  }

  protected passVerifyAppOtpResponse(res) {
    this.loadFlag = false;
    this.app_2fa_secret = res.app_2fa_secret;
    const svgString = this.unescapeXml(res.qr_code);
    this.qr_code = this.sanitizer.bypassSecurityTrustHtml(svgString);
  }

  protected passVerifyAppOtpError(error) {
    this.loadFlag = false;
    this.errorMsg = error.message;
    const data = {
      message: this.errorMsg,
      confirmBtn: 'Ok',
      isIcoEnable: true
    };
    this.dialog.open(AlertMessageDialogComponent, {data, disableClose: true, width: '500px'});
  }

  protected passCompleteAppOtpResponse(res) {
    this.loadFlag = false;
    this.showSnackBar('2FA App set up successfully', 'OK', 5000);
    // close this dialog
    this.dialogRef.close(true);
  }

  protected passCompleteAppOtpError(error) {
    this.loadFlag = false;
    this.errorMsg = error.message;
    const data = {
      message: this.errorMsg,
      confirmBtn: 'Ok',
      isIcoEnable: true
    };
    this.dialog.open(AlertMessageDialogComponent, {data, disableClose: true, width: '500px'});
  }

  private unescapeXml(escapedXml: string): string {
    const element = document.createElement('textarea');
    element.innerHTML = escapedXml;
    return element.value;
  }

}
